import { createSlice } from '@reduxjs/toolkit'
import retrieveDepartments from './departmentsThunk'

const defaultActiveSort = 'LAST_ADDED'

const initialState = {
  pageNumber: 0,
  summaries: {},
  sortBy: ['LAST_ADDED', 'LAST_UPDATED', 'NAME', 'Name_TRANSLATED'],
  activeSort: defaultActiveSort,
  value: [],
  loading: false,
}

const departmentsSlice = createSlice({
  name: 'departments',
  initialState,

  extraReducers: {
    [retrieveDepartments.pending]: (state) => {
      state.loading = true
      state.finalPage = true
    },
    [retrieveDepartments.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.value = payload
    },
  },
})

export const selectDepartments = ({ departments }) => departments
export const { activeSummaryHandler } = departmentsSlice.actions

export default departmentsSlice.reducer
